/* eslint-disable */
// @ts-nocheck
import { PUBLIC_META_PIXEL_ID } from '$env/static/public'
import type { PurchaseData } from '$lib/types/metaTracking'

export function initMetaPixel() {
  if (window) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    fbq('init', PUBLIC_META_PIXEL_ID)
    fbq('track', 'PageView')
  }
}

/* eslint-enable */
// @ts-check
function metaPixelBaseTrack(
  eventName: string,
  data: Record<string, string | number | null | undefined>,
) {
  if (window && 'fbq' in window && typeof window.fbq === 'function') {
    window.fbq('track', eventName, data)
  }
}

export const metaPixelTrack = {
  purchase: (data: PurchaseData) => metaPixelBaseTrack('Purchase', data),
}
